import { Outlet } from 'react-router-dom';

export const VehicleOutlet = () => <Outlet />;
